import { useState } from 'react';

// Standard success/error banner for julkisivu v2 table mutations — pairs
// with useApiFeedback. An "ℹ" toggle reveals the raw API response so errors
// (and successes) can be inspected/copied instead of just trusting a
// one-line message.
export default function ApiFeedbackBanner({ feedback, onClose }) {
  const [showInfo, setShowInfo] = useState(false);
  if (!feedback) return null;
  const { ok, message, response } = feedback;

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 10,
      background: ok ? '#d1e7dd' : '#f8d7da', border: `1px solid ${ok ? '#badbcc' : '#f5c2c7'}`,
      borderRadius: 4, padding: '6px 10px', fontSize: '0.78rem', color: ok ? '#0f5132' : '#842029',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ flex: 1 }}>{ok ? '✓' : '⚠'} {message}</span>
        <button type="button" onClick={() => setShowInfo(v => !v)} title="Näytä API-vastaus"
          style={{
            border: '1px solid currentColor', background: showInfo ? 'rgba(0,0,0,0.08)' : 'transparent', color: 'inherit',
            borderRadius: '50%', width: 18, height: 18, lineHeight: '16px', fontSize: '0.7rem', fontWeight: 700,
            cursor: 'pointer', flex: '0 0 auto', padding: 0,
          }}>i</button>
        <button type="button" onClick={onClose} title="Piilota"
          style={{ border: 'none', background: 'none', color: 'inherit', cursor: 'pointer', fontSize: '0.9rem', flex: '0 0 auto', opacity: 0.7 }}>×</button>
      </div>
      {showInfo && (
        <pre style={{
          margin: 0, background: 'rgba(0,0,0,0.06)', borderRadius: 4, padding: '8px 10px',
          fontSize: '0.72rem', maxHeight: 220, overflow: 'auto', userSelect: 'text', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
        }}>{JSON.stringify(response, null, 2) ?? 'ei vastausdataa'}</pre>
      )}
    </div>
  );
}
